import React from 'react';
import ReactDOM from 'react-dom';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/core/styles';
import allReducers from './store/reducers';
import App from './App';
import theme from './consts/theme';
import './index.css';
import 'rsuite/dist/rsuite.min.css';
import history from './history.js';

const store = createStore(allReducers);

ReactDOM.render(
  <BrowserRouter history={history}>
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <App />
      </Provider>
    </ThemeProvider>
  </BrowserRouter>,
  document.getElementById('root')
);
